module.exports = __webpack_public_path__ + "img/image11-1.d4a8c904.jpeg";